export default {
  UPDATE_CRITERIA: 'UPDATE_CRITERIA',
  REMOVE_CRITERIA: 'REMOVE_CRITERIA',
  CLEAR_ALL_CRITERIA: 'CLEAR_ALL_CRITERIA',
};



// WEBPACK FOOTER //
// ./src/reducers/grid/types.js